import React, { useEffect, useState } from 'react';
import { GoogleMap, Marker, InfoWindow, useJsApiLoader } from '@react-google-maps/api';
import { API_BASE_URL } from './config';

const containerStyle = {
  width: '600px',
  height: '400px'
};

export default function GoogleMapWithPlant() {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyBxKX7n8GWbfptF_Haqjwm0sLrmo5GSZbg',
  });

  const [clusters, setClusters] = useState([]);
  const [selectedCluster, setSelectedCluster] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE_URL}/dev/api/location-summary`)
      .then(res => res.json())
      .then(data => {
        console.log('[GoogleMapWithPlant] Location summary response:', data);
        if (Array.isArray(data)) {
          setClusters(data);
        } else {
          setError(`Unexpected response format: ${typeof data}`);
        }
      })
      .catch(err => {
        console.error('[GoogleMapWithPlant] Failed to load location summary:', err);
        setError(`Failed to load: ${err.message}`);
      });
  }, []);

  if (!isLoaded) return <div style={{ padding: '1em', color: '#999' }}>Loading map...</div>;

  const valid = clusters.filter(c => c.lat && c.lon);
  if (error) {
    return <div style={{ padding: '1em', color: 'red', fontSize: '0.9em' }}>Map error: {error}</div>;
  }
  if (valid.length === 0) {
    return <div style={{ padding: '1em', color: '#999', fontSize: '0.9em' }}>No location data available (clusters: {clusters.length})</div>;
  }

  const centerLat = valid.reduce((s, c) => s + c.lat, 0) / valid.length;
  const centerLon = valid.reduce((s, c) => s + c.lon, 0) / valid.length;

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={{ lat: centerLat, lng: centerLon }}
      zoom={8}
    >
      {valid.map(cluster => (
        <Marker
          key={cluster.zipcode}
          position={{ lat: cluster.lat, lng: cluster.lon }}
          label={{ text: String(cluster.count), color: 'white', fontWeight: 'bold' }}
          title={`Zipcode ${cluster.zipcode}: ${cluster.count.toLocaleString('en-US')} device${cluster.count !== 1 ? 's' : ''}`}
          onClick={() => setSelectedCluster(cluster)}
        />
      ))}
      {selectedCluster && (
        <InfoWindow
          position={{ lat: selectedCluster.lat, lng: selectedCluster.lon }}
          onCloseClick={() => setSelectedCluster(null)}
        >
          <div style={{ color: '#000' }}>
            <strong>{selectedCluster.zipcode}</strong><br />
            {selectedCluster.count} device{selectedCluster.count !== 1 ? 's' : ''}
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  );
}
